import { z } from 'zod';

import { ResultadoBinario } from '@/types/enums';

export const ectoparasitosMuestraSchema = z.object({
  categoria: z.string().min(1, 'Requerido'),
  muestra: z.string().min(1, 'Requerido'),
  valor: z.enum([ResultadoBinario.POSITIVO, ResultadoBinario.NEGATIVO], {
    message: 'Seleccioná un resultado',
  }),
  descripcion_resultado: z.string().nullable(),
  observacion: z.string().nullable(),
});

export const ectoparasitosFormSchema = z.object({
  fecha_analisis: z.date({ message: 'Fecha de análisis inválida' }),
  identificacion_muestras: z.string().nullable(),
  muestra: ectoparasitosMuestraSchema,
});

export type EctoparasitosFormValues = z.infer<typeof ectoparasitosFormSchema>;
export type EctoparasitosMuestraFormValues = z.infer<typeof ectoparasitosMuestraSchema>;
